import React from 'react';

export interface Sign6IconProps {}

export const Sign6Icon: React.FC<Sign6IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7262 15.8479L10.6754 15.8527L5.21887 16.7452L7.17421 21.917C7.22429 22.0495 7.34472 22.1424 7.48554 22.1573C7.67433 22.1773 7.8452 22.0535 7.88914 21.8741L7.8979 21.8238L8.13603 19.5712C10.9237 20.9955 14.246 20.7628 16.8004 19.0168L16.9558 18.908L15.7908 17.2824C13.8529 18.6711 11.303 18.8945 9.14872 17.8415L10.9566 16.526C11.0711 16.4427 11.1289 16.302 11.1061 16.1622C11.0754 15.9749 10.9109 15.8428 10.7262 15.8479ZM15.5045 4.25411L14.6792 6.07585C16.8508 7.05975 18.3193 9.15634 18.4844 11.5485L16.4413 10.6406C16.3119 10.5831 16.1611 10.6034 16.0515 10.6931C15.9058 10.8123 15.873 11.0184 15.9668 11.1753L15.9987 11.2207L19.5 15.5L23.0012 11.2207C23.0908 11.1112 23.1111 10.9604 23.0536 10.831C22.9765 10.6575 22.7839 10.5714 22.6065 10.6231L22.5586 10.6406L20.4887 11.5607C20.3282 8.43072 18.4614 5.66711 15.6668 4.32968L15.5045 4.25411ZM5.4607 3.01178C5.34994 3.16403 5.37044 3.37171 5.5009 3.49975L5.54332 3.53564L7.37491 4.86834C4.74561 6.57175 3.28587 9.56861 3.52356 12.6562L3.5395 12.8379L5.52987 12.6419C5.29616 10.2693 6.37749 7.94943 8.3664 6.61028L8.60201 8.83344C8.6169 8.97426 8.70985 9.09469 8.84231 9.14477C9.01989 9.21191 9.21654 9.13543 9.3045 8.973L9.3257 8.92662L11.281 3.75483L5.82447 2.86232C5.68472 2.83946 5.54401 2.89727 5.4607 3.01178Z"
        fill="#192033"
      />
    </svg>
  );
};
